/**
 * @function
 * @name preventNumbers
 * invokes event.preventDefault and event.stopPropagation if event key is number
 * prevents number input
 * @param {event}
 */

export const preventNumbers = e => {
  if (/\d/.test(e.key)) {
    e.preventDefault();
    e.stopPropagation();
  }
};

/**
 * @function
 * @name prventSpaces
 * invokes event.preventDefault and event.stopPropagation if event key is number
 * prevents white spaces input
 * @param {event}
 */

export const preventSpaces = e => {
  if (/\s/.test(e.key)) {
    e.preventDefault();
    e.stopPropagation();
  }
};

/**
 * @function
 * @name preventNonnumeric
 * invokes event.preventDefault if event key is a non-numeric character
 * @param {event}
 */

export const preventNonNumeric = (e, handleChange) => {
  const regex = /^[0-9\b]+$/;

  if (e.target.value === '' || regex.test(e.target.value)) {
    return handleChange(e);
  }
};

/**
 * @function
 * @name preventSpecialChars
 * invokes event.preventDefault if event key is a number or special character
 * @param {event}
 */

export const preventSpecialChars = (e, handleChange) => {
  const regex = /[^a-zA-ZıİçÇşŞğĞÜüÖö\s]/g;
  if (e.target.value === '' || !regex.test(e.target.value)) handleChange(e);
};

/**
 * @function
 * @name preventOnlySpecialChars
 * invokes event.preventDefault if event key is an only special character
 * @param {event}
 */

export const preventOnlySpecialChars = (e, handleChange) => {
  const regex = /[^a-zA-ZıİçÇşŞğĞÜüÖö0-9\s]/g;
  if (e.target.value === '' || !regex.test(e.target.value)) handleChange(e);
};

/**
 * Validates that the version in xx.xx.xx format
 * If invalid, makes it valid by adding 0 to the beginning
 * @param {string} version
 * @returns {string}
 */

export const produceValidVersion = version => {
  let versionArr = version.split('.');
  let mapVersion = versionArr.map(ver => {
    return ver.length === 1 ? '0' + ver : ver;
  });

  return mapVersion.join('.');
};

/**
 * @function
 * @param {string} text
 * @returns capitalized {string}
 */

export const _capitalize = string => {
  if (string) {
    const words = string.split(/\s/);
    const formattedStr = words.map(word => {
      return word.charAt(0).toUpperCase() + word.substring(1).toLowerCase();
    });
    return formattedStr.join(' ');
  }
};

/**
 * @function
 * @name convertToSlug
 * converts string to slug
 * @param {event}
 */

export const convertToSlug = str => {
  return str
    .toUpperCase()
    .toLowerCase()
    .trim()
    .normalize('NFD')
    .replace(/[^\w-]+/g, '')
    .replace(/\s+/g, '-');
};

/**
 * @function
 * @name currencyFormatter
 * converts number to currency format
 * @param {event}
 */

const defaultOptions = {
  significantDigits: 2,
  thousandsSeparator: ',',
  decimalSeparator: '.',
  symbol: '₺'
};

export const currencyFormatter = (value, options) => {
  if (typeof value !== 'number') value = 0.0;
  options = { ...defaultOptions, ...options };
  value = value.toFixed(options.significantDigits);

  const [currency, decimal] = value.split('.');
  return `${options.symbol} ${currency.replace(
    /\B(?=(\d{3})+(?!\d))/g,
    options.thousandsSeparator
  )}${options.decimalSeparator}${decimal}`;
};
